import { TweenVar } from '@/data/data-models';

export const tweenVarProps = {
    BACKGROUND_COLOR: 'backgroundColor',
    BORDER_COLOR: 'borderColor',
    BORDER_RADIUS: 'borderRadius',
    BOX_SHADOW: 'boxShadow',
    COLOR: 'color',
    DOWN: 'down',
    FONT_SIZE: 'fontSize',
    FONT_WEIGHT: 'fontWeight',
    HEIGHT: 'height',
    LEFT: 'left',
    LETTER_SPACING: 'letterSpacing',
    MARGIN: 'margin',
    MAX_HEIGHT: 'maxHeight',
    OPACITY: 'opacity',
    PADDING: 'padding',
    RIGHT: 'right',
    ROTATE: 'rotate',
    SCALE: 'scale',
    UP: 'up',
    WIDTH: 'width',
};

// maps the props above to their gsap counterparts
export const tweenVarPropMap = {
    [tweenVarProps.BACKGROUND_COLOR]: 'backgroundColor',
    [tweenVarProps.BORDER_COLOR]: 'borderColor',
    [tweenVarProps.BORDER_RADIUS]: 'borderRadius',
    [tweenVarProps.BOX_SHADOW]: 'boxShadow',
    [tweenVarProps.DOWN]: 'y',
    [tweenVarProps.COLOR]: 'color',
    [tweenVarProps.FONT_SIZE]: 'fontSize',
    [tweenVarProps.FONT_WEIGHT]: 'fontWeight',
    [tweenVarProps.HEIGHT]: 'height',
    [tweenVarProps.LEFT]: 'x',
    [tweenVarProps.LETTER_SPACING]: 'letterSpacing',
    [tweenVarProps.MARGIN]: 'margin',
    [tweenVarProps.MAX_HEIGHT]: 'maxHeight',
    [tweenVarProps.OPACITY]: 'opacity',
    [tweenVarProps.PADDING]: 'padding',
    [tweenVarProps.RIGHT]: 'x',
    [tweenVarProps.ROTATE]: 'rotate',
    [tweenVarProps.SCALE]: 'scale',
    [tweenVarProps.UP]: 'y',
    [tweenVarProps.WIDTH]: 'width',
};

// the order that the categories are displayed in here will be maintained elsewhere, e.g. in the animation step <select> menu
export const tweenVarCategories = {
    COLOR: 'color',
    POSITION: 'position',
    SHAPE: 'shape',
    DISPLAY: 'display',
    TEXT: 'text',
};

// the order of the exported Map will be maintained as well
export default new Map([
    // colors
    [tweenVarProps.COLOR, new TweenVar({
        label: 'Text Color',
        prop: tweenVarProps.COLOR,
        category: tweenVarCategories.COLOR,
        component: 'tween-input-color',
        units: [''],
    })],

    [tweenVarProps.BACKGROUND_COLOR, new TweenVar({
        label: 'Background Color',
        prop: tweenVarProps.BACKGROUND_COLOR,
        category: tweenVarCategories.COLOR,
        component: 'tween-input-color',
        units: [''],
    })],

    [tweenVarProps.BORDER_COLOR, new TweenVar({
        label: 'Border Color',
        prop: tweenVarProps.BORDER_COLOR,
        category: tweenVarCategories.COLOR,
        component: 'tween-input-color',
        units: [''],
    })],

    // positioning
    [tweenVarProps.UP, new TweenVar({
        label: 'Up',
        prop: tweenVarProps.UP,
        category: tweenVarCategories.POSITION,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.DOWN, new TweenVar({
        label: 'Down',
        prop: tweenVarProps.DOWN,
        category: tweenVarCategories.POSITION,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.LEFT, new TweenVar({
        label: 'Left',
        prop: tweenVarProps.LEFT,
        category: tweenVarCategories.POSITION,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.RIGHT, new TweenVar({
        label: 'Right',
        prop: tweenVarProps.RIGHT,
        category: tweenVarCategories.POSITION,
        component: 'tween-input-number',
        units: ['px'],
    })],

    // dimensions
    [tweenVarProps.WIDTH, new TweenVar({
        label: 'Width',
        prop: tweenVarProps.WIDTH,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['px', '%'],
    })],

    [tweenVarProps.HEIGHT, new TweenVar({
        label: 'Height',
        prop: tweenVarProps.HEIGHT,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['px', '%', 'vh'],
    })],

    [tweenVarProps.MAX_HEIGHT, new TweenVar({
        label: 'Max Height',
        prop: tweenVarProps.MAX_HEIGHT,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['px', '%', 'vh'],
    })],

    [tweenVarProps.PADDING, new TweenVar({
        label: 'Padding',
        prop: tweenVarProps.PADDING,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.MARGIN, new TweenVar({
        label: 'Margin',
        prop: tweenVarProps.MARGIN,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.BORDER_RADIUS, new TweenVar({
        label: 'Border Radius',
        prop: tweenVarProps.BORDER_RADIUS,
        category: tweenVarCategories.SHAPE,
        component: 'tween-input-number',
        units: ['%', 'px'],
    })],

    // display
    [tweenVarProps.OPACITY, new TweenVar({
        label: 'Opacity',
        prop: tweenVarProps.OPACITY,
        category: tweenVarCategories.DISPLAY,
        component: 'tween-input-number',
        units: ['%'],
    })],

    [tweenVarProps.ROTATE, new TweenVar({
        label: 'Rotation',
        prop: tweenVarProps.ROTATE,
        category: tweenVarCategories.DISPLAY,
        component: 'tween-input-number',
        units: ['deg'],
    })],

    [tweenVarProps.SCALE, new TweenVar({
        label: 'Scale',
        prop: tweenVarProps.SCALE,
        category: tweenVarCategories.DISPLAY,
        component: 'tween-input-number',
        units: ['%'],
    })],

    [tweenVarProps.BOX_SHADOW, new TweenVar({
        label: 'Box Shadow',
        prop: tweenVarProps.BOX_SHADOW,
        category: tweenVarCategories.DISPLAY,
        component: 'tween-input-text',
        units: [''],
    })],

    // text
    [tweenVarProps.FONT_SIZE, new TweenVar({
        label: 'Font Size',
        prop: tweenVarProps.FONT_SIZE,
        category: tweenVarCategories.TEXT,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.FONT_WEIGHT, new TweenVar({
        label: 'Font Weight',
        prop: tweenVarProps.FONT_WEIGHT,
        category: tweenVarCategories.TEXT,
        component: 'tween-input-number',
        units: ['px'],
    })],

    [tweenVarProps.LETTER_SPACING, new TweenVar({
        label: 'Letter Spacing',
        prop: tweenVarProps.LETTER_SPACING,
        category: tweenVarCategories.TEXT,
        component: 'tween-input-number',
        units: ['px'],
    })],
]);
